module.exports = __webpack_public_path__ + "img/if_1.0359ab15.png";